import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useStyles } from './HomePage.styles';
import { useDeploymentInfo } from '../hooks/useDeploymentInfo';
import Jumbotron from './Jumbotron';
import SiteCard from './SiteCard';
import DeploymentFooter from './DeploymentFooter';
import { siteCards } from './siteCardsConfig';

function HomePage({ isAuthenticated, onLogin }) {
  const classes = useStyles();
  const navigate = useNavigate();
  const deploymentInfo = useDeploymentInfo();

  const handleCardClick = (path, isExternal = false) => {
    if (isExternal) {
      window.open(path, '_blank');
    } else {
      navigate(path);
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <Jumbotron isAuthenticated={isAuthenticated} onLogin={onLogin} />

        <div className={classes.sitesContainer}>
          {siteCards.map((card) => (
            <SiteCard
              key={card.id}
              title={card.title}
              description={card.description}
              icon={card.icon}
              iconColor={card.color}
              onClick={() => isAuthenticated ? handleCardClick(card.path, card.isExternal) : onLogin()}
            />
          ))}
        </div>
      </div>

      <DeploymentFooter deploymentInfo={deploymentInfo} />
    </div>
  );
}

export default HomePage;